// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * How it works
 * Page layout only.
 */

.HowItWorks_page__5ynGE {
  padding-bottom: 0;
  --container: calc(1160px + 2 * var(--gutter));
}

/* Hero group */
div.HowItWorks_heroBlock__SkoCr {
  gap: var(--space-6);
}

div.HowItWorks_block__NIXQn {
  gap: var(--space-16);
  padding-block: var(--space-16);
}

/* Needs strip */
/* What a session asks of you */
.HowItWorks_needs__nKGmZ {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
  padding: var(--space-4) 0 0;
}

.HowItWorks_need__VEyNw {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: 0 var(--space-6);
  border-left: 1px solid var(--border);
}

.HowItWorks_need__VEyNw:first-child {
  padding-left: 0;
  border-left: none;
}

.HowItWorks_need__VEyNw:last-child {
  padding-right: 0;
}

.HowItWorks_needText__TnbFR {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.HowItWorks_needLabel__3IKdV {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: -0.014em;
  color: var(--text-primary);
}

.HowItWorks_needNote__5TQWd {
  margin-top: 2px;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

@media (max-width: 760px) {
  .HowItWorks_needs__nKGmZ {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-4);
  }

  .HowItWorks_need__VEyNw {
    padding: var(--space-4) 0 0;
    border-left: none;
    border-top: 1px solid var(--border);
  }

  .HowItWorks_need__VEyNw:first-child {
    padding-top: var(--space-4);
    border-top: 1px solid var(--border);
  }
}

/* Shared section heads */
.HowItWorks_head__7tQ4u {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 54ch;
}

.HowItWorks_title__Byy68 {
  font-size: clamp(1.35rem, 1.08rem + 0.95vw, 1.85rem);
  font-weight: 700;
  line-height: 1.18;
  letter-spacing: -0.022em;
  text-wrap: balance;
}

.HowItWorks_lead__bE31l {
  font-size: 1.0625rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.HowItWorks_subhead__qTcJ\\+ {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.4;
  color: var(--text-primary);
}

/* Home practice + timeline */
.HowItWorks_session__IMxKp {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  gap: clamp(var(--space-8), 4vw, 56px);
  align-items: start;
}

.HowItWorks_sessionMedia__LxSpj {
  position: sticky;
  /* Clears the 54px sticky navbar, plus a little air. */
  top: calc(54px + var(--space-4));
  margin: 0;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--gray-200);
  box-shadow: var(--shadow-md);
  aspect-ratio: 3 / 4;
  /* Never taller than the viewport it is pinned in. */
  max-height: calc(100dvh - 120px);
}

.HowItWorks_sessionMedia__LxSpj img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.HowItWorks_sessionBody__vdzbM {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  padding-top: var(--space-1);
}

.HowItWorks_timeline__DZyb4 {
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.HowItWorks_tlItem__v4SjB {
  position: relative;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  column-gap: var(--space-4);
  row-gap: var(--space-1);
  align-items: start;
}

.HowItWorks_tlItem__v4SjB:not(:last-child)::before {
  content: "";
  position: absolute;
  left: 16px;
  top: 34px;
  bottom: calc(-1 * var(--space-8));
  width: 1px;
  background: var(--border);
}

.HowItWorks_tlNum__GKT1g {
  position: relative;
  grid-row: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-full);
  background: var(--primary);
  color: var(--text-on-primary);
  font-size: 0.9375rem;
  font-weight: 700;
  /* A ring of page colour so the rail appears to pass behind the number. */
  box-shadow: 0 0 0 5px var(--bg);
}

.HowItWorks_tlTitle__HYr69 {
  grid-column: 2;
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.5;
  color: var(--text-primary);
}

.HowItWorks_tlBody__R0Xnu {
  grid-column: 2;
  font-size: 0.9375rem;
  line-height: 1.65;
  color: var(--text-secondary);
  max-width: 56ch;
}

@media (max-width: 900px) {
  .HowItWorks_session__IMxKp {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-8);
  }

  .HowItWorks_sessionMedia__LxSpj {
    position: static;
    aspect-ratio: 16 / 10;
    max-width: none;
    width: 100%;
  }
}

/* Bands */
.HowItWorks_band__yiKKM {
  background: var(--bg-tertiary);
  border-top: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
  padding: var(--space-16) 0;
}

.HowItWorks_bandWash__uoFPg {
  background: var(--surface-brand-wash);
  border-top-color: var(--surface-selected);
  border-bottom-color: var(--surface-selected);
}

span.HowItWorks_bandLabel__LHKYA {
  color: var(--primary);
}

/* The kit */
.HowItWorks_bandGrid__4TMVM {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: clamp(var(--space-8), 4vw, 56px);
  align-items: center;
}

.HowItWorks_kitCopy__M8AS\\+ {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-width: 52ch;
}

.HowItWorks_kitCopy__M8AS\\+ .HowItWorks_title__Byy68 {
  margin-top: 2px;
}

.HowItWorks_kitNote__oE6BD {
  font-size: 0.9375rem;
  line-height: 1.6;
  color: var(--text-primary);
  padding-left: var(--space-4);
  border-left: 2px solid var(--surface-selected);
  max-width: 46ch;
}

.HowItWorks_kitCopy__M8AS\\+ > a {
  align-self: flex-start;
  margin-top: var(--space-2);
}

.HowItWorks_kitFrames__snc65 {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.85fr);
  gap: var(--space-5);
  align-items: start;
}

.HowItWorks_kitFrame__6Qtud {
  margin: 0;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--gray-200);
  box-shadow: var(--shadow-md);
}

.HowItWorks_kitFrame__6Qtud img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.HowItWorks_kitFrameWide__qhRdq {
  aspect-ratio: 4 / 3;
}

.HowItWorks_kitFrameTall__1t1c7 {
  aspect-ratio: 3 / 4;
  margin-top: clamp(24px, 4vw, 64px);
}

@media (max-width: 900px) {
  .HowItWorks_band__yiKKM {
    padding: var(--space-12) 0;
  }

  .HowItWorks_bandGrid__4TMVM {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-8);
  }

  .HowItWorks_kitFrameTall__1t1c7 {
    margin-top: 0;
  }
}

/* Phones: the two kit photos sit side by side as matching tiles. */
@media (max-width: 560px) {
  .HowItWorks_kitFrames__snc65 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-3);
  }

  .HowItWorks_kitFrameWide__qhRdq,
  .HowItWorks_kitFrameTall__1t1c7 {
    aspect-ratio: 4 / 5;
  }
}

/* The gap and the answer */
.HowItWorks_contrast__VbBNo {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: clamp(var(--space-8), 4vw, 56px);
  align-items: start;
}

.HowItWorks_contrastCol__nxt8C {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.HowItWorks_contrastCol__nxt8C + .HowItWorks_contrastCol__nxt8C {
  padding-left: calc(clamp(var(--space-8), 4vw, 56px) / 2);
  border-left: 1px solid var(--border);
  margin-left: calc(-1 * clamp(var(--space-8), 4vw, 56px) / 2);
}

.HowItWorks_colTitle__Ivlvz {
  font-size: clamp(1.15rem, 1.02rem + 0.5vw, 1.4rem);
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.018em;
  color: var(--text-primary);
}

.HowItWorks_colLead__V\\+yYj {
  font-size: 0.9375rem;
  line-height: 1.65;
  color: var(--text-secondary);
  max-width: 52ch;
}

.HowItWorks_colNote__zDkKU {
  margin-top: auto;
  padding-top: var(--space-4);
  border-top: 1px solid var(--border-light);
  font-size: 0.875rem;
  line-height: 1.6;
  color: var(--text-secondary);
  max-width: 48ch;
}

/* Checked points */
.HowItWorks_checks__yMjr- {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.HowItWorks_checks__yMjr- li {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-primary);
}

.HowItWorks_checkIcon__hZpSw {
  flex: none;
  width: 19px;
  height: 19px;
  margin-top: 2px;
  color: var(--primary);
}

@media (max-width: 820px) {
  .HowItWorks_contrast__VbBNo {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-8);
  }

  .HowItWorks_contrastCol__nxt8C + .HowItWorks_contrastCol__nxt8C {
    margin-left: 0;
    padding-left: 0;
    padding-top: var(--space-8);
    border-left: none;
    border-top: 1px solid var(--border);
  }
}

/* What teams evaluate */
.HowItWorks_benefits__zpdm0 {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-8) 0;
  margin: 0;
  padding: 0;
}

.HowItWorks_benefit__9Xjp3 {
  padding: 0 var(--space-6);
  border-left: 1px solid var(--surface-selected);
}

.HowItWorks_benefit__9Xjp3:nth-child(3n + 1) {
  padding-left: 0;
  border-left: none;
}

.HowItWorks_benefit__9Xjp3:nth-child(3n) {
  padding-right: 0;
}

.HowItWorks_benefitIcon__8nqan {
  width: 20px;
  height: 20px;
  color: var(--primary);
  margin-bottom: var(--space-3);
}

.HowItWorks_benefitTitle__tX3WA {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;
  color: var(--text-primary);
}

.HowItWorks_benefitBody__cTnjK {
  margin-top: 4px;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: var(--text-secondary);
  max-width: 38ch;
}

@media (max-width: 900px) {
  .HowItWorks_benefits__zpdm0 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-6) 0;
  }

  .HowItWorks_benefit__9Xjp3,
  .HowItWorks_benefit__9Xjp3:nth-child(3n + 1) {
    padding: 0 var(--space-5);
    border-left: 1px solid var(--surface-selected);
  }

  .HowItWorks_benefit__9Xjp3:nth-child(2n + 1) {
    padding-left: 0;
    border-left: none;
  }

  .HowItWorks_benefit__9Xjp3:nth-child(2n) {
    padding-right: 0;
  }
}

@media (max-width: 560px) {
  .HowItWorks_benefits__zpdm0 {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }

  .HowItWorks_benefit__9Xjp3,
  .HowItWorks_benefit__9Xjp3:nth-child(3n + 1),
  .HowItWorks_benefit__9Xjp3:nth-child(2n + 1) {
    padding: var(--space-5) 0;
    border-left: none;
    border-top: 1px solid var(--surface-selected);
  }

  .HowItWorks_benefit__9Xjp3:first-child {
    padding-top: 0;
    border-top: none;
  }

  /* Icon beside the title instead of on its own line. */
  .HowItWorks_benefit__9Xjp3,
  .HowItWorks_benefit__9Xjp3:nth-child(3n + 1),
  .HowItWorks_benefit__9Xjp3:nth-child(2n + 1) {
    display: grid;
    grid-template-columns: 18px minmax(0, 1fr);
    column-gap: var(--space-3);
    padding-block: var(--space-4);
  }

  .HowItWorks_benefitIcon__8nqan {
    width: 18px;
    height: 18px;
    margin: 2px 0 0;
  }

  .HowItWorks_benefitTitle__tX3WA {
    font-size: .9375rem;
  }

  .HowItWorks_benefitBody__cTnjK {
    grid-column: 2;
    max-width: none;
    font-size: .875rem;
  }
}

/* Patients and provider teams */
.HowItWorks_audience__XPkA9 {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

/* Column widths follow each photo's aspect ratio so both render at equal height, uncropped. */
.HowItWorks_audienceGrid__pecZ5 {
  display: grid;
  grid-template-columns: minmax(0, 1330fr) minmax(0, 928fr);
  gap: var(--space-4);
}

.HowItWorks_audienceShot__4UQbB {
  margin: 0;
  border-radius: var(--radius-lg);
  overflow: hidden;
  border: 1px solid var(--border);
  background: var(--bg-secondary);
  box-shadow: var(--shadow-sm);
}

.HowItWorks_audienceShot__4UQbB img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.HowItWorks_audienceShotHome__IaWo5 {
  aspect-ratio: 1330 / 749;
}

.HowItWorks_audienceShotMug__YGvJg {
  aspect-ratio: 2673 / 2160;
}

@media (max-width: 700px) {
  .HowItWorks_audienceGrid__pecZ5 {
    gap: var(--space-2);
  }

  .HowItWorks_audienceShot__4UQbB {
    border-radius: var(--radius-md);
  }
}

/* Closing */
section.HowItWorks_closing__PwwxJ .ui-hero-copy {
  max-width: 62ch;
}

section.HowItWorks_closing__PwwxJ h2 {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.28;
  letter-spacing: -0.018em;
}

section.HowItWorks_closing__PwwxJ .ui-hero-copy p {
  font-size: 0.9375rem;
  line-height: 1.55;
}

@media (max-width: 480px) {
  section.HowItWorks_closing__PwwxJ .ui-btn-row {
    align-self: stretch;
  }

  section.HowItWorks_closing__PwwxJ .ui-btn-row > * {
    flex: 1 1 100%;
  }
}

/* Phones: tighter section rhythm and type. */
@media (max-width: 560px) {
  div.HowItWorks_heroBlock__SkoCr {
    gap: var(--space-5);
  }

  div.HowItWorks_block__NIXQn {
    gap: var(--space-8);
    padding-block: var(--space-8);
  }

  .HowItWorks_band__yiKKM {
    padding: var(--space-8) 0;
  }

  .HowItWorks_title__Byy68 {
    font-size: 1.25rem;
  }

  .HowItWorks_lead__bE31l {
    font-size: .9375rem;
  }

  .HowItWorks_needs__nKGmZ {
    gap: var(--space-3);
  }

  .HowItWorks_need__VEyNw,
  .HowItWorks_need__VEyNw:first-child {
    padding-top: var(--space-3);
  }

  .HowItWorks_needLabel__3IKdV {
    font-size: .9375rem;
  }

  .HowItWorks_needNote__5TQWd {
    font-size: .8125rem;
  }

  .HowItWorks_session__IMxKp {
    gap: var(--space-5);
  }

  .HowItWorks_sessionMedia__LxSpj {
    aspect-ratio: 16 / 9;
  }

  .HowItWorks_timeline__DZyb4 {
    gap: var(--space-5);
  }

  .HowItWorks_tlItem__v4SjB {
    grid-template-columns: 28px minmax(0, 1fr);
    column-gap: var(--space-3);
    row-gap: 2px;
  }

  .HowItWorks_tlItem__v4SjB:not(:last-child)::before {
    left: 13px;
    top: 28px;
    bottom: calc(-1 * var(--space-5));
  }

  .HowItWorks_tlNum__GKT1g {
    grid-row: span 2;
    width: 28px;
    height: 28px;
    font-size: .8125rem;
  }

  .HowItWorks_tlTitle__HYr69 {
    font-size: .9375rem;
    line-height: 1.4;
  }

  .HowItWorks_tlBody__R0Xnu {
    font-size: .875rem;
    line-height: 1.55;
  }

  .HowItWorks_contrast__VbBNo {
    gap: var(--space-6);
  }

  .HowItWorks_colTitle__Ivlvz {
    font-size: 1.0625rem;
  }

  .HowItWorks_colLead__V\\+yYj,
  .HowItWorks_checks__yMjr- li {
    font-size: .875rem;
  }

  .HowItWorks_colNote__zDkKU {
    font-size: .8125rem;
  }

  .HowItWorks_bandGrid__4TMVM {
    gap: var(--space-5);
  }

  .HowItWorks_audience__XPkA9 {
    gap: var(--space-5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/HowItWorks.module.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,mCAAmC;EACrC;;EAEA;IACE,2BAA2B;IAC3B,mCAAmC;EACrC;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,wDAAwD;EACxD,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sDAAsD;EACtD,gCAAgC;EAChC,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,oDAAoD;EACpD,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iCAAiC;EACjC,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,yEAAyE;EACzE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,WAAW;EACb;AACF;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,wDAAwD;EACxD,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mEAAmE;AACnE;EACE;IACE,gDAAgD;IAChD,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,gDAAgD;EAChD,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;EACxD,oCAAoC;EACpC,4DAA4D;AAC9D;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,mCAAmC;EACrC;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE;IACE,gDAAgD;IAChD,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;IACzB,8CAA8C;EAChD;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,MAAM;EACR;;EAEA;;;IAGE,yBAAyB;IACzB,iBAAiB;IACjB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,sDAAsD;EACtD;;;IAGE,aAAa;IACb,0CAA0C;IAC1C,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,8FAA8F;AAC9F;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,YAAY;AACZ;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,UAAU;IACV,SAAS;IACT,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * How it works\n * Page layout only.\n */\n\n.page {\n  padding-bottom: 0;\n  --container: calc(1160px + 2 * var(--gutter));\n}\n\n/* Hero group */\ndiv.heroBlock {\n  gap: var(--space-6);\n}\n\ndiv.block {\n  gap: var(--space-16);\n  padding-block: var(--space-16);\n}\n\n/* Needs strip */\n/* What a session asks of you */\n.needs {\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin: 0;\n  padding: var(--space-4) 0 0;\n}\n\n.need {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding: 0 var(--space-6);\n  border-left: 1px solid var(--border);\n}\n\n.need:first-child {\n  padding-left: 0;\n  border-left: none;\n}\n\n.need:last-child {\n  padding-right: 0;\n}\n\n.needText {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.needLabel {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.35;\n  letter-spacing: -0.014em;\n  color: var(--text-primary);\n}\n\n.needNote {\n  margin-top: 2px;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n@media (max-width: 760px) {\n  .needs {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-4);\n  }\n\n  .need {\n    padding: var(--space-4) 0 0;\n    border-left: none;\n    border-top: 1px solid var(--border);\n  }\n\n  .need:first-child {\n    padding-top: var(--space-4);\n    border-top: 1px solid var(--border);\n  }\n}\n\n/* Shared section heads */\n.head {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  max-width: 54ch;\n}\n\n.title {\n  font-size: clamp(1.35rem, 1.08rem + 0.95vw, 1.85rem);\n  font-weight: 700;\n  line-height: 1.18;\n  letter-spacing: -0.022em;\n  text-wrap: balance;\n}\n\n.lead {\n  font-size: 1.0625rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.subhead {\n  margin: 0;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n/* Home practice + timeline */\n.session {\n  display: grid;\n  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n  gap: clamp(var(--space-8), 4vw, 56px);\n  align-items: start;\n}\n\n.sessionMedia {\n  position: sticky;\n  /* Clears the 54px sticky navbar, plus a little air. */\n  top: calc(54px + var(--space-4));\n  margin: 0;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--gray-200);\n  box-shadow: var(--shadow-md);\n  aspect-ratio: 3 / 4;\n  /* Never taller than the viewport it is pinned in. */\n  max-height: calc(100dvh - 120px);\n}\n\n.sessionMedia img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.sessionBody {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n  padding-top: var(--space-1);\n}\n\n.timeline {\n  position: relative;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-8);\n}\n\n.tlItem {\n  position: relative;\n  display: grid;\n  grid-template-columns: 34px minmax(0, 1fr);\n  column-gap: var(--space-4);\n  row-gap: var(--space-1);\n  align-items: start;\n}\n\n.tlItem:not(:last-child)::before {\n  content: \"\";\n  position: absolute;\n  left: 16px;\n  top: 34px;\n  bottom: calc(-1 * var(--space-8));\n  width: 1px;\n  background: var(--border);\n}\n\n.tlNum {\n  position: relative;\n  grid-row: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-full);\n  background: var(--primary);\n  color: var(--text-on-primary);\n  font-size: 0.9375rem;\n  font-weight: 700;\n  /* A ring of page colour so the rail appears to pass behind the number. */\n  box-shadow: 0 0 0 5px var(--bg);\n}\n\n.tlTitle {\n  grid-column: 2;\n  margin: 0;\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.5;\n  color: var(--text-primary);\n}\n\n.tlBody {\n  grid-column: 2;\n  font-size: 0.9375rem;\n  line-height: 1.65;\n  color: var(--text-secondary);\n  max-width: 56ch;\n}\n\n@media (max-width: 900px) {\n  .session {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-8);\n  }\n\n  .sessionMedia {\n    position: static;\n    aspect-ratio: 16 / 10;\n    max-width: none;\n    width: 100%;\n  }\n}\n\n/* Bands */\n.band {\n  background: var(--bg-tertiary);\n  border-top: 1px solid var(--border-light);\n  border-bottom: 1px solid var(--border-light);\n  padding: var(--space-16) 0;\n}\n\n.bandWash {\n  background: var(--surface-brand-wash);\n  border-top-color: var(--surface-selected);\n  border-bottom-color: var(--surface-selected);\n}\n\nspan.bandLabel {\n  color: var(--primary);\n}\n\n/* The kit */\n.bandGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n  gap: clamp(var(--space-8), 4vw, 56px);\n  align-items: center;\n}\n\n.kitCopy {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  max-width: 52ch;\n}\n\n.kitCopy .title {\n  margin-top: 2px;\n}\n\n.kitNote {\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  color: var(--text-primary);\n  padding-left: var(--space-4);\n  border-left: 2px solid var(--surface-selected);\n  max-width: 46ch;\n}\n\n.kitCopy > a {\n  align-self: flex-start;\n  margin-top: var(--space-2);\n}\n\n.kitFrames {\n  display: grid;\n  grid-template-columns: minmax(0, 1.25fr) minmax(0, 0.85fr);\n  gap: var(--space-5);\n  align-items: start;\n}\n\n.kitFrame {\n  margin: 0;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--gray-200);\n  box-shadow: var(--shadow-md);\n}\n\n.kitFrame img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.kitFrameWide {\n  aspect-ratio: 4 / 3;\n}\n\n.kitFrameTall {\n  aspect-ratio: 3 / 4;\n  margin-top: clamp(24px, 4vw, 64px);\n}\n\n@media (max-width: 900px) {\n  .band {\n    padding: var(--space-12) 0;\n  }\n\n  .bandGrid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-8);\n  }\n\n  .kitFrameTall {\n    margin-top: 0;\n  }\n}\n\n/* Phones: the two kit photos sit side by side as matching tiles. */\n@media (max-width: 560px) {\n  .kitFrames {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--space-3);\n  }\n\n  .kitFrameWide,\n  .kitFrameTall {\n    aspect-ratio: 4 / 5;\n  }\n}\n\n/* The gap and the answer */\n.contrast {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: clamp(var(--space-8), 4vw, 56px);\n  align-items: start;\n}\n\n.contrastCol {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n.contrastCol + .contrastCol {\n  padding-left: calc(clamp(var(--space-8), 4vw, 56px) / 2);\n  border-left: 1px solid var(--border);\n  margin-left: calc(-1 * clamp(var(--space-8), 4vw, 56px) / 2);\n}\n\n.colTitle {\n  font-size: clamp(1.15rem, 1.02rem + 0.5vw, 1.4rem);\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.018em;\n  color: var(--text-primary);\n}\n\n.colLead {\n  font-size: 0.9375rem;\n  line-height: 1.65;\n  color: var(--text-secondary);\n  max-width: 52ch;\n}\n\n.colNote {\n  margin-top: auto;\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border-light);\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: var(--text-secondary);\n  max-width: 48ch;\n}\n\n/* Checked points */\n.checks {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.checks li {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-primary);\n}\n\n.checkIcon {\n  flex: none;\n  width: 19px;\n  height: 19px;\n  margin-top: 2px;\n  color: var(--primary);\n}\n\n@media (max-width: 820px) {\n  .contrast {\n    grid-template-columns: minmax(0, 1fr);\n    gap: var(--space-8);\n  }\n\n  .contrastCol + .contrastCol {\n    margin-left: 0;\n    padding-left: 0;\n    padding-top: var(--space-8);\n    border-left: none;\n    border-top: 1px solid var(--border);\n  }\n}\n\n/* What teams evaluate */\n.benefits {\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-8) 0;\n  margin: 0;\n  padding: 0;\n}\n\n.benefit {\n  padding: 0 var(--space-6);\n  border-left: 1px solid var(--surface-selected);\n}\n\n.benefit:nth-child(3n + 1) {\n  padding-left: 0;\n  border-left: none;\n}\n\n.benefit:nth-child(3n) {\n  padding-right: 0;\n}\n\n.benefitIcon {\n  width: 20px;\n  height: 20px;\n  color: var(--primary);\n  margin-bottom: var(--space-3);\n}\n\n.benefitTitle {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.4;\n  color: var(--text-primary);\n}\n\n.benefitBody {\n  margin-top: 4px;\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  color: var(--text-secondary);\n  max-width: 38ch;\n}\n\n@media (max-width: 900px) {\n  .benefits {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--space-6) 0;\n  }\n\n  .benefit,\n  .benefit:nth-child(3n + 1) {\n    padding: 0 var(--space-5);\n    border-left: 1px solid var(--surface-selected);\n  }\n\n  .benefit:nth-child(2n + 1) {\n    padding-left: 0;\n    border-left: none;\n  }\n\n  .benefit:nth-child(2n) {\n    padding-right: 0;\n  }\n}\n\n@media (max-width: 560px) {\n  .benefits {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 0;\n  }\n\n  .benefit,\n  .benefit:nth-child(3n + 1),\n  .benefit:nth-child(2n + 1) {\n    padding: var(--space-5) 0;\n    border-left: none;\n    border-top: 1px solid var(--surface-selected);\n  }\n\n  .benefit:first-child {\n    padding-top: 0;\n    border-top: none;\n  }\n\n  /* Icon beside the title instead of on its own line. */\n  .benefit,\n  .benefit:nth-child(3n + 1),\n  .benefit:nth-child(2n + 1) {\n    display: grid;\n    grid-template-columns: 18px minmax(0, 1fr);\n    column-gap: var(--space-3);\n    padding-block: var(--space-4);\n  }\n\n  .benefitIcon {\n    width: 18px;\n    height: 18px;\n    margin: 2px 0 0;\n  }\n\n  .benefitTitle {\n    font-size: .9375rem;\n  }\n\n  .benefitBody {\n    grid-column: 2;\n    max-width: none;\n    font-size: .875rem;\n  }\n}\n\n/* Patients and provider teams */\n.audience {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-8);\n}\n\n/* Column widths follow each photo's aspect ratio so both render at equal height, uncropped. */\n.audienceGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 1330fr) minmax(0, 928fr);\n  gap: var(--space-4);\n}\n\n.audienceShot {\n  margin: 0;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  border: 1px solid var(--border);\n  background: var(--bg-secondary);\n  box-shadow: var(--shadow-sm);\n}\n\n.audienceShot img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.audienceShotHome {\n  aspect-ratio: 1330 / 749;\n}\n\n.audienceShotMug {\n  aspect-ratio: 2673 / 2160;\n}\n\n@media (max-width: 700px) {\n  .audienceGrid {\n    gap: var(--space-2);\n  }\n\n  .audienceShot {\n    border-radius: var(--radius-md);\n  }\n}\n\n/* Closing */\nsection.closing :global(.ui-hero-copy) {\n  max-width: 62ch;\n}\n\nsection.closing h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  line-height: 1.28;\n  letter-spacing: -0.018em;\n}\n\nsection.closing :global(.ui-hero-copy) p {\n  font-size: 0.9375rem;\n  line-height: 1.55;\n}\n\n@media (max-width: 480px) {\n  section.closing :global(.ui-btn-row) {\n    align-self: stretch;\n  }\n\n  section.closing :global(.ui-btn-row) > * {\n    flex: 1 1 100%;\n  }\n}\n\n/* Phones: tighter section rhythm and type. */\n@media (max-width: 560px) {\n  div.heroBlock {\n    gap: var(--space-5);\n  }\n\n  div.block {\n    gap: var(--space-8);\n    padding-block: var(--space-8);\n  }\n\n  .band {\n    padding: var(--space-8) 0;\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n\n  .lead {\n    font-size: .9375rem;\n  }\n\n  .needs {\n    gap: var(--space-3);\n  }\n\n  .need,\n  .need:first-child {\n    padding-top: var(--space-3);\n  }\n\n  .needLabel {\n    font-size: .9375rem;\n  }\n\n  .needNote {\n    font-size: .8125rem;\n  }\n\n  .session {\n    gap: var(--space-5);\n  }\n\n  .sessionMedia {\n    aspect-ratio: 16 / 9;\n  }\n\n  .timeline {\n    gap: var(--space-5);\n  }\n\n  .tlItem {\n    grid-template-columns: 28px minmax(0, 1fr);\n    column-gap: var(--space-3);\n    row-gap: 2px;\n  }\n\n  .tlItem:not(:last-child)::before {\n    left: 13px;\n    top: 28px;\n    bottom: calc(-1 * var(--space-5));\n  }\n\n  .tlNum {\n    grid-row: span 2;\n    width: 28px;\n    height: 28px;\n    font-size: .8125rem;\n  }\n\n  .tlTitle {\n    font-size: .9375rem;\n    line-height: 1.4;\n  }\n\n  .tlBody {\n    font-size: .875rem;\n    line-height: 1.55;\n  }\n\n  .contrast {\n    gap: var(--space-6);\n  }\n\n  .colTitle {\n    font-size: 1.0625rem;\n  }\n\n  .colLead,\n  .checks li {\n    font-size: .875rem;\n  }\n\n  .colNote {\n    font-size: .8125rem;\n  }\n\n  .bandGrid {\n    gap: var(--space-5);\n  }\n\n  .audience {\n    gap: var(--space-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `HowItWorks_page__5ynGE`,
	"heroBlock": `HowItWorks_heroBlock__SkoCr`,
	"block": `HowItWorks_block__NIXQn`,
	"needs": `HowItWorks_needs__nKGmZ`,
	"need": `HowItWorks_need__VEyNw`,
	"needText": `HowItWorks_needText__TnbFR`,
	"needLabel": `HowItWorks_needLabel__3IKdV`,
	"needNote": `HowItWorks_needNote__5TQWd`,
	"head": `HowItWorks_head__7tQ4u`,
	"title": `HowItWorks_title__Byy68`,
	"lead": `HowItWorks_lead__bE31l`,
	"subhead": `HowItWorks_subhead__qTcJ+`,
	"session": `HowItWorks_session__IMxKp`,
	"sessionMedia": `HowItWorks_sessionMedia__LxSpj`,
	"sessionBody": `HowItWorks_sessionBody__vdzbM`,
	"timeline": `HowItWorks_timeline__DZyb4`,
	"tlItem": `HowItWorks_tlItem__v4SjB`,
	"tlNum": `HowItWorks_tlNum__GKT1g`,
	"tlTitle": `HowItWorks_tlTitle__HYr69`,
	"tlBody": `HowItWorks_tlBody__R0Xnu`,
	"band": `HowItWorks_band__yiKKM`,
	"bandWash": `HowItWorks_bandWash__uoFPg`,
	"bandLabel": `HowItWorks_bandLabel__LHKYA`,
	"bandGrid": `HowItWorks_bandGrid__4TMVM`,
	"kitCopy": `HowItWorks_kitCopy__M8AS+`,
	"kitNote": `HowItWorks_kitNote__oE6BD`,
	"kitFrames": `HowItWorks_kitFrames__snc65`,
	"kitFrame": `HowItWorks_kitFrame__6Qtud`,
	"kitFrameWide": `HowItWorks_kitFrameWide__qhRdq`,
	"kitFrameTall": `HowItWorks_kitFrameTall__1t1c7`,
	"contrast": `HowItWorks_contrast__VbBNo`,
	"contrastCol": `HowItWorks_contrastCol__nxt8C`,
	"colTitle": `HowItWorks_colTitle__Ivlvz`,
	"colLead": `HowItWorks_colLead__V+yYj`,
	"colNote": `HowItWorks_colNote__zDkKU`,
	"checks": `HowItWorks_checks__yMjr-`,
	"checkIcon": `HowItWorks_checkIcon__hZpSw`,
	"benefits": `HowItWorks_benefits__zpdm0`,
	"benefit": `HowItWorks_benefit__9Xjp3`,
	"benefitIcon": `HowItWorks_benefitIcon__8nqan`,
	"benefitTitle": `HowItWorks_benefitTitle__tX3WA`,
	"benefitBody": `HowItWorks_benefitBody__cTnjK`,
	"audience": `HowItWorks_audience__XPkA9`,
	"audienceGrid": `HowItWorks_audienceGrid__pecZ5`,
	"audienceShot": `HowItWorks_audienceShot__4UQbB`,
	"audienceShotHome": `HowItWorks_audienceShotHome__IaWo5`,
	"audienceShotMug": `HowItWorks_audienceShotMug__YGvJg`,
	"closing": `HowItWorks_closing__PwwxJ`
};
export default ___CSS_LOADER_EXPORT___;
